// project import

// types
import { NavItemType } from "types/menu";

// ==============================|| MENU ITEMS ||============================== //

const menuItems: { items: NavItemType[] } = {
  //items: [applications, pages, other],
  items: [],
};

export default menuItems;
